<nz-spin [nzSpinning]="!this.isData">
  <div class="grid grid-cols-12">
    <div class="mb-3 col-span-6">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input [(ngModel)]="this.name" [ngModelOptions]="{standalone: true}" type="text"
               nz-input [placeholder]="'itineraries.addImageModel.placeholders.enterText' | transloco"/>
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" [disabled]="this.name === ''" (click)="getPexelsImageAPI(this.name);"
                nzSearch><span
          nz-icon
          nzType="search"></span>
        </button>
      </ng-template>
    </div>
  </div>
  <div class="grid grid-cols-2 gap-8">
    <div>
      <div>
        <img class="w-full h-56 object-cover"
             [src]="getSelectedImage()"
             alt=""/>
      </div>
    </div>
    <div>
      <div>
        <nz-radio-group
          class="my-3 justify-items-center custom-radio-radius grid grid-cols-2 "
          nzButtonStyle="solid"
          [(ngModel)]="this.selectedImage" [ngModelOptions]="{standalone: true}">
          <label
            class="w-full h-48  p-1 mb-2"
            *ngFor="let img of this.pexelsImage.photos"
            nz-radio-button
            [nzValue]="img.src.large">
            <img
              class="w-full h-full object-cover"
              [src]="img.src.large"
              alt=""/>
          </label>
        </nz-radio-group>
      </div>
    </div>
  </div>
  <div class="text-end mt-3">
    <button
      nz-button
      nzType="primary"
      (click)="submit()"
      [disabled]="this.selectedImage === ''">
      {{ 'itineraries.addImageModel.actions.add' | transloco }}
    </button>
  </div>
</nz-spin>
